import { Outlet } from 'react-router'

import { AppProvider } from '@/context/AppContext'
import { PrintProvider } from '@/context/PrintContext'
import { WithAuth } from '@/hoc/WithAuth'
import { InsuranceParamsProvider } from '../context/InsuranceParamsProvider'
import type { LeasingBaseLayoutProps } from './LeasingBaseLayout'


const _LeasingWizardLayout = ({ app }: LeasingBaseLayoutProps) => {
  return (
    <InsuranceParamsProvider>
      {/* <Header /> */}

      <Outlet />
    </InsuranceParamsProvider>
  )
}

const __LeasingWizardLayout = WithAuth(_LeasingWizardLayout)

export const LeasingWizardLayout = (props: LeasingBaseLayoutProps) => {
  return (
    <AppProvider app={props.app}>
      <PrintProvider>
        <__LeasingWizardLayout {...props} />
      </PrintProvider>
    </AppProvider>
  )
}